import Api from '@/service/api';
import Auth from '@/service/auth';

import isValidSession from '@/helpers/check-session';

import Success from '@/views/SignIn/Success/index.vue';

import MultiloginInput from '@/components/Form/MultiloginInput/index.vue';
import Input from '@/components/Form/Input/index.vue';
import Checkbox from '@/components/Form/Checkbox/index.vue';

import ERROR_CODES from '@/constants/error-codes';


export default {
  name: 'SignIn',

  components: {
    MultiloginInput,
    Input,
    Checkbox,
    Success,
  },

  methods: {
    async signIn() {
      if (!this.validate()) {
        return;
      }

      this.isSignInDisabled = true;

      try {
        await Api.post({
          url: 'sign-in',
          data: {
            login: this.login,
            password: this.password,
            remember_me: this.isCheckedRememberMe,
          },
        });
      } catch (error) {
        if (error.status === 429) {
          this.isAttempt = true;
          this.isError = true;
          this.errorCode = error.code;

          return;
        }

        if (error.status === 401 || error.status === 400) {
          if (error.data.errors[0].code === ERROR_CODES.PASSWORD_RESTORATION_REQUIRED) {
            this.$router.push({ name: 'PasswordRestoration' });
            return;
          }
          this.isSignInDisabled = false;
          this.validated = false;
          this.isError = true;
          this.errorCode = error.data.errors[0].code;

          return;
        }

        this.isServerError = true;
        return;
      }

      this.isSignInDisabled = false;
      this.isAuth = Auth.isAuthenticated();

      if (this.$store.getters.isCallback) {
        this.getTicket();
      }
    },

    async getTicket() {
      let response = '';

      try {
        response = await Api.post({
          url: 'get-ticket',
          data: {
            session_id: this.session,
          },
          preloader: false,
        });
      } catch (error) {
        this.isServerError = true;
        return;
      }

      if (response) {
        this.ticket = response.ticket;
        this.$store.commit('setIsCallback', false);
      }
    },

    validate() {
      if (!this.$refs.multiLogin.validate()) {
        this.validated = false;
      }

      if (!this.$refs.password.validate()) {
        this.validated = false;
      }

      if (!this.$refs.termsOfUseAgreementCheckbox.validate()) {
        this.validated = false;
      }

      return this.validated;
    },

    fieldsChanged() {
      if (!this.isAttempt) {
        this.validated = true;
        this.isError = false;
      }
    },

    async onSignOut() {
      try {
        await Api.post({
          url: 'sign-out',
          data: {
            session_id: this.session,
          },
        });
      } catch (error) {
        window.console.log(error);
      }

      this.isAuth = Auth.isAuthenticated();
    },
  },

  async created() {
    if (Auth.isAuthenticated()) {
      this.isAuth = true;
      this.sessionId = Auth.getSession();
      const isValidSessionId = await isValidSession(this.sessionId);

      if (!isValidSessionId) {
        this.isAuth = Auth.isAuthenticated();
      }

      if (this.$store.getters.isCallback) {
        this.getTicket();
      }
    }
  },

  data() {
    return {
      validated: this.validated || true,
      isAuth: false,
      isError: false,
      isCheckedRememberMe: false,
      isCheckedTermsOfUseAgreement: false,
      isServerError: false,
      password: null,
      login: null,
      errorCode: null,
      isSignInDisabled: false,
      ticket: '',
    };
  },
};
